// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2oJ4U","list":"PatternAutocomplete_list__3QrDD"};